/*
 * TableContext  component
 *
 * @package editor
 * @copyright 2021-2025 Hexio a.s. <contact@hexio.io> (hexio.io) and contributors.
 * @license Apache-2.0
 *
 * See LICENSE file distributed with this source code for more information.
 */

import React, { useContext } from "react";
import { ITableColumnConfig } from "./TableTypes";

export interface ITableContextValue {
	columnsConfig?: Map<string, ITableColumnConfig>;
	selectedRows?: string[];
	rowSelectable?: boolean;
	onRowClick?: (rowId: string) => void;
	headerHeight?: number;
}

export const TableContext = React.createContext<ITableContextValue>({});

export function useTableContext(): ITableContextValue {
	return useContext(TableContext);
}
